module.exports = __webpack_public_path__ + "icono_quality_directorio.png";